(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getTarget(hash) {
    if (!hash || hash === '#') return null;

    var id = decodeURIComponent(hash.slice(1));
    var target = document.getElementById(id);
    if (target) return target;

    var anchors = document.querySelectorAll('[data-smooth-anchor]');
    for (var index = 0; index < anchors.length; index += 1) {
      if (anchors[index].getAttribute('data-smooth-anchor') === id) return anchors[index];
    }

    return null;
  }

  function scrollToTarget(target, behavior) {
    var marginTop = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - marginTop;

    window.scrollTo({
      top: top,
      behavior: prefersReducedMotion.matches ? 'auto' : behavior,
    });

    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link) return;

    var url = new URL(link.href, window.location.href);
    if (url.pathname !== window.location.pathname || url.search !== window.location.search) return;

    var target = getTarget(url.hash);
    if (!target) return;

    event.preventDefault();
    history.pushState(null, '', url.hash);
    scrollToTarget(target, 'smooth');
  });

  window.addEventListener('load', function () {
    var target = getTarget(window.location.hash);
    if (target) scrollToTarget(target, 'auto');
  });
})();
